import React from "react";
import { renderContent } from "../../utilities/renderContent";
import { linkFormat } from "../../utilities/linkFormat";

export default function AnnouncementBar({
  isDisplayed,
  text,
  link,
  bgColor,
  textColor,
}) {
  const WrapWithLink = ({ condition, wrap, children }) =>
    condition ? wrap(children) : children;

  if (!isDisplayed) {
    return <></>;
  }
  return (
    <WrapWithLink
      condition={link}
      wrap={(children) => (
        <a href={linkFormat(link)} className="block">
          {children}
        </a>
      )}
    >
      <div
        className="w-full text-md py-2 text-center"
        dangerouslySetInnerHTML={renderContent(text)}
        style={{
          color: textColor ? textColor.hex : "#fff",
          backgroundColor: bgColor ? bgColor.hex : "#09A7E2",
        }}
      />
    </WrapWithLink>
  );
}
